module.exports = __webpack_public_path__ + "fc82f8d2.svg";